import { createTheme } from '@mui/material/styles';

const fontOpenSans = { fontFamily: '"OpenSans", sans-serif' };
const fontCeraProBold = { fontFamily: '"CeraPro Bold", sans-serif' };
const fontCeraProMedium = { fontFamily: '"CeraPro Medium", sans-serif' };
const fontCeraProRegular = { fontFamily: '"CeraPro Regular", sans-serif' };
const fontsFilter = { fontSize: 14, fontFamily: '"CeraPro Regular", sans-serif' };

/** Font family for main application text. */
export const openSans = fontOpenSans;

/** Font family for headers. */
export const ceraProBold = fontCeraProBold;

/** Font family for labels. */
export const ceraProMedium = fontCeraProMedium;

/** Font family for context menus and buttons. */
export const ceraProRegular = fontCeraProRegular;

/** Font size and font family for column filters. */
export const filterFonts = fontsFilter;

/** Application Theme. */
const Theme = createTheme({
    palette: {
        primary: {
            main: '#44AC34',
        },
        secondary: {
            main: '#edf2ff',
        },
        text: {
            disabled: '#444',
        },
        action: {
            disabled: '#444',
            disabledOpacity: 0.6,
        },
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#88D2E7',
                        borderRadius: '7px',
                    },
                    '&:not(.Mui-disabled):hover': {
                        backgroundColor: '#cdeef6',
                        borderRadius: '7px',
                    },
                    // Disabled: opacity zurücksetzen, Farben selbst steuern
                    '&.Mui-disabled': {
                        opacity: 1,
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.25)',
                        },
                    },
                    '&.Mui-disabled .MuiSelect-icon': {
                        color: '#111',
                        opacity: 0.6,
                    },
                },
                input: {
                    '&.Mui-disabled': {
                        WebkitTextFillColor: '#111',
                        opacity: 1,
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: '#222',
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: '#222',
                    },
                },
            },
        },
    },
    typography: {
        h1: {
            ...fontCeraProBold,
        },
        h2: {
            ...fontCeraProBold,
        },
        h3: {
            ...fontCeraProBold,
        },
        h4: {
            ...fontCeraProBold,
        },
        h5: {
            ...fontCeraProBold,
        },
        h6: {
            ...fontCeraProBold,
        },
        body1: {
            ...fontOpenSans,
        },
        body2: {
            ...fontOpenSans,
        },
    },
});

export default Theme;

/** Default application border style. */
export const defaultBorder = `1px solid ${Theme.palette.divider}`;

/** Color variables. */
export const vars = {
    black: '#000' as const,
    font: '#434343' as const,
    concrete: '#898B8E' as const,
    midGray: '#C2C2C2' as const,
    lightGray: '#DEDEDE' as const,
    fillGray: '#F2F2F2' as const,
    bgGray: '#FBFBFB' as const,
    white: '#FFF' as const,

    errorRed: '#B00020' as const,
    errorBgRed: '#F8E6E9' as const,
    errorDialogRed: '#C62C3B' as const,

    warningYellow: '#E6B012' as const,
    warningBgYellow: '#FDF7E8' as const,
    warningInactiveBgYellow: '#FEFCF6' as const,

    logoBlue: '#0F3949' as const,

    trafficLightGreen: '#A6D326',

    brandGreen: '#44AC34' as const,
    brandOrange: '#FF8400' as const,
    brandPink: '#F8374A' as const,
    brandLightBlue: '#88D2E7' as const,
    brandBlue: '#003C4D' as const,
    brandYellow: '#FBC62A' as const,
    brandDarkBlue: '#245A6D' as const,
    brandDarkBlueSecondary: '#2D7188' as const,

    hoverGreen: '#2E8B20' as const,
    mainGreen: '#44AC34' as const,
    inactiveGreen: '#8FCD85' as const,
    bgGreen: '#EDF7EB' as const,
    bgGreenHover: '#B4DEAE' as const,
    selectedBgGreen: '#DAEED6' as const,
    selectedHoveredGreen: '#368A2A' as const,
    infoBlue: '#30C1B0' as const,

    red: '#F8374A' as const,

    chipTeal: '#30C1B0' as const,
    chipDarkBlue: '#1B4452' as const,

    tagChipBlue: '#42B5D3' as const,

    testDoc: '#bb0000' as const,
};

/** Default Action column width. */
export const actionColumnWidth = 96;

/**Height of the each list item on the Project Selection Dropdown */
export const projectSelectionListHeight = 40;

/**Height of the search field inside the Project Selection Dropdown */
export const projectSelectionSearchFieldHeight = 55;

/**Height of the project selection link inside the Project Selection Dropdown */
export const projectSelectionLinkHeight = projectSelectionListHeight;

/**Padding of the project selection link inside the Project Selection Dropdown */
export const projectSelectionLinkPadding = 8;

/**Display none style for the elements that has missing features */
export const displayNoneStyle = { display: 'none' };
